import { FormSelect } from '@tryhackme/thm-ui-components';
import { RoadmapVariant } from '../../roadmap.types';
import { StyledCareerPathSelectorContainer } from './career-path-selector.styles';
import { CAREER_PATHS } from './career-path-selector.constants';
export const CareerPathSelector = ({
  selectedOption,
  handleSelection,
  variant
}: {
  selectedOption: {
    value: string;
    label: string;
  } | undefined;
  handleSelection: (args: {
    value: string;
    label: string;
  } | undefined) => void;
  variant: RoadmapVariant;
}) => <StyledCareerPathSelectorContainer data-sentry-element="StyledCareerPathSelectorContainer" data-sentry-component="CareerPathSelector" data-sentry-source-file="career-path-selector.tsx">
    <p className="title">Cyber Security Career Skills</p>
    <p className="subtitle">
      {variant === 'welcome' ? 'Master the specific skills necessary for your career of interest.' : ' Master the specific skills necessary for your career of interest. Not sure which career path is right for you?Take our career quiz to find out.'}
    </p>
    <FormSelect isSearchable={false} options={CAREER_PATHS} selected={selectedOption} handleSelection={option => handleSelection(option)} forceDarkMode placeholder="Select a career path" data-sentry-element="FormSelect" data-sentry-source-file="career-path-selector.tsx" />
  </StyledCareerPathSelectorContainer>;